import baseRequest from "../_core/baseRequest";

export default {
    listCourierBonusCampaigns: params => baseRequest.post("/courier-bonus-campaigns/list", params),
    createCourierBonusCampaign: params => baseRequest.post("/courier-bonus-campaigns", params),
    updateCourierBonusCampaign: params =>
        baseRequest.put(`/courier-bonus-campaigns/${params._id}`, params),
    deleteCourierBonusCampaign: params =>
        baseRequest.put(`/courier-bonus-campaigns/${params._id}/delete`)
};
